import { ActionBase } from './action-base';
import { type } from '../../shared/components/helpers/util';

/**
 * Dealer Option Action Types
 */
export const LOCAL_SPECIAL_ACTION = {
  LOAD: type('LOCAL_SPECIAL_LOAD'),
  SET: type('LOCAL_SPECIAL_SET'),
  CLEAR: type('LOCAL_SPECIAL_CLEAR')
};

/**
 * LocalSpecialActionLoad
 */
export class LocalSpecialActionLoad implements ActionBase {
  public readonly type: string = LOCAL_SPECIAL_ACTION.LOAD;
  constructor() {}
}

/**
 * LocalSpecialActionSet
 */
export class LocalSpecialActionSet implements ActionBase {
  public readonly type: string = LOCAL_SPECIAL_ACTION.SET;
  constructor(public payload: any[]) {}
}

/**
 * LocalSpecialActionClear
 */
export class LocalSpecialActionClear implements ActionBase {
  public readonly type: string = LOCAL_SPECIAL_ACTION.CLEAR;
  constructor() {}
}

export type Any = LocalSpecialActionLoad |
LocalSpecialActionSet |
LocalSpecialActionClear;
